// Copy-pasted from:
// https://github.com/davidramos-om/zipcelx-on-steroids/blob/master/src/formatters/rows/generatorRows.js

import generateRow from './row'

export default function generateRows(data, {
	schema,
	headerStyle,
	getStyle,
	getSharedString,
	customFont,
	dateFormat
}) {
	if (schema) {
		let header = [];
		for (const column of schema) {
			// If at least one schema column has a title,
			// then print a header row.
			if (column.column) {
				header = [schema.map((column) => ({
					type: String,
					value: column.column,
					align: column.align,
					// `headerStyle` also overwrites `align`, if specified.
					...(headerStyle || DEFAULT_HEADER_STYLE)
				}))]
				break
			}
		}
		data = header.concat(data.map((row) => schema.map(
			(column) => ({
				...column,
				format: column.format || (column.type === Date ? dateFormat : undefined),
				value: column.value(row)
			})
		)))
	}
	return data.map((row, index) => generateRow(row, index, {
		getStyle,
		getSharedString,
		customFont
	})).join('')
}

const DEFAULT_HEADER_STYLE = {
	fontWeight: 'bold'
}